import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MobileLayout from '@/components/MobileLayout';
import TopBar from '@/components/TopBar';
import { api } from '@/lib/api';
import { Loader2, ExternalLink, FileText, CheckCircle2, XCircle } from 'lucide-react';

export default function History() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/articles');
        setArticles(data);
      } finally { setLoading(false); }
    })();
  }, []);

  const statusBadge = (s) => {
    if (s === 'published') return <span className="inline-flex items-center gap-1 text-xs font-semibold text-green-700 bg-green-50 px-2 py-0.5 rounded-md"><CheckCircle2 size={12} /> Publié</span>;
    if (s === 'error') return <span className="inline-flex items-center gap-1 text-xs font-semibold text-red-700 bg-red-50 px-2 py-0.5 rounded-md"><XCircle size={12} /> Erreur</span>;
    return <span className="inline-flex items-center gap-1 text-xs font-semibold text-slate-700 bg-slate-100 px-2 py-0.5 rounded-md"><FileText size={12} /> Brouillon</span>;
  };

  return (
    <MobileLayout>
      <TopBar />
      <div className="px-5 py-4 border-b border-slate-100">
        <h1 className="text-xl font-bold text-slate-900" data-testid="history-title">Historique</h1>
      </div>

      <div className="px-5 pt-4 pb-6 space-y-3" data-testid="history-list">
        {loading && <div className="py-10 text-center"><Loader2 className="mx-auto animate-spin text-blue-600" /></div>}
        {!loading && articles.length === 0 && (
          <div className="py-20 text-center">
            <div className="mx-auto w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-3">
              <FileText className="text-slate-400" />
            </div>
            <p className="text-slate-700 font-semibold">Aucun article</p>
            <p className="text-sm text-slate-500">Vos articles générés apparaîtront ici.</p>
          </div>
        )}
        {articles.map((a) => (
          <article
            key={a.id}
            onClick={() => nav(`/preview/${a.id}`)}
            className="bg-white border border-slate-200 rounded-2xl p-4 hover:shadow-md transition cursor-pointer"
            data-testid={`history-item-${a.id}`}
          >
            <div className="flex items-start gap-3">
              {a.image_url && (
                <img src={a.image_url} alt="" className="w-16 h-16 rounded-lg object-cover bg-slate-100 flex-shrink-0"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }} />
              )}
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-slate-900 line-clamp-2 text-sm">{a.title}</h3>
                <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                  {statusBadge(a.status)}
                  <span className="text-xs text-slate-400">
                    {new Date(a.created_at).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
                {a.published_url && (
                  <a href={a.published_url} target="_blank" rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="inline-flex items-center gap-1 text-xs text-blue-600 font-semibold mt-1.5">
                    Voir sur le site <ExternalLink size={10} />
                  </a>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </MobileLayout>
  );
}
